//
// Must match EnumDateTimeAggregation.java
//
export const DAY = 'day';
export const WEEK = 'week';
export const MONTH = 'month';
export const QUARTER = 'quarter';
export const YEAR = 'year';

export const dateOptions = [DAY, WEEK, MONTH, QUARTER, YEAR];
